/**
 * Etiquetas de los tipos de artículo de un ítem de remito
 * (`RemitoItemModel.articleType`).
 *
 * Catálogo ABIERTO a propósito: un tipo nuevo (las jeringas, que todavía no
 * existen) se muestra con su valor crudo vía `resolveLabel` hasta que se le
 * agregue la entrada acá — no hace falta tocar la consulta ni los reportes.
 */
export const ARTICLE_TYPE_LABELS: Record<string, string> = {
  bag: 'Bolsa',
  guia: 'Guía',
  filtro: 'Filtro',
};
